<template>
  <div id="teamLineup">
    <h1 class = "team-lineup-title"> {{$t('about.teamLineup.title')}} </h1>
    <div id="container">
      <div v-for="(member, index) in team" :key="index" :style="member.style" class="member">
        <div class="above-container">
          <div class="member-name">
            <h1 v-html="member.name"></h1>
            <h1 class = "is-hidden-desktop"> {{ $t(member.position).toUpperCase()}} </h1>
          </div>
        </div>
        <div class="member-image-container">
          <img :style="member.imgStyle" class="image" :src="member.imgSrc">
        </div>
        <div class="bellow-container">
          <div class="member-title is-hidden-mobile">
            <h1>{{ $t(member.position).toUpperCase()}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      team: [
        {
          name: "BIANCA<br class=\"is-hidden-mobile\"> CIOBĂNIȚĂ",
          position: "about.teamLineup.logistic",
          imgSrc: "https://i.imgur.com/OI9NoBt.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 1.17,
            offsetValue: 6,
            mobile: {
              widthModifier: 60
            }
          }
        },
        {
          name: "ANCA<br class=\"is-hidden-mobile\"> ȘOLOT",
          position: "about.teamLineup.academic",
          imgSrc: "https://i.imgur.com/f96eSf7.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 0.8,
            offsetValue: 3.7,
            mobile: {
              widthModifier: 40,
              offsetValue: 0
            }
          }
        },
        {
          name: "ADRIANA<br class=\"is-hidden-mobile\"> COLNICEANU",
          position: "about.teamLineup.fr",
          imgSrc: "https://i.imgur.com/ki59cRQ.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 0.9,
            offsetValue: 0.1,
            mobile: {
              widthModifier: 40,
              offsetValue: 20
            }
          }
        },
        {
          name: "IULIA<br class=\"is-hidden-mobile\"> BLÎNDU",
          position: "about.teamLineup.coordinator",
          imgSrc: "https://i.imgur.com/ZPWS4vC.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 1,
            offsetValue: 4.1,
            mobile: {
              widthModifier: 50,
              offsetValue: 0
            }
          }
        },
        {
          name: "RADU<br class=\"is-hidden-mobile\"> BUCUR",
          position: "about.teamLineup.pr",
          imgSrc: "https://i.imgur.com/8bdiO6u.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 1,
            offsetValue: 0,
            mobile: {
              widthModifier: 50,
              offsetValue: 0
            }
          }
        },
        {
          name: "PAUL<br class=\"is-hidden-mobile\"> BUHAI",
          position: "about.teamLineup.technical",
          imgSrc: "https://i.imgur.com/wk1eAAb.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 0.93,
            offsetValue: 6,
            mobile: {
              widthModifier: 50,
              offsetValue: 0
            }
          }
        },
        {
          name: "MIHAI<br class=\"is-hidden-mobile\"> STOICHIȚOIU",
          position: "about.teamLineup.hr",
          imgSrc: "https://i.imgur.com/yDYDOSe.png",
          style: "",
          imgStyle: "",
          imgProps: {
            widthModifier: 1.18,
            offsetValue: 8,
            mobile: {
              widthModifier: 60,
              offsetValue: 0
            }
          }
        }
      ]
    };
  },
  created: function() {
    var zIndexBase = 500;
    var baseWidth = 17;
    var middle = this.team.length / 2 - 0.5;

    for (let member of this.team) {
      let i = this.team.indexOf(member);
      let mobile = window.innerWidth < 600 ? true : false
      
      var widthStyle = "width: " + baseWidth * member.imgProps.widthModifier + "vw;";
      var marginStyleValue = "-" + member.imgProps.offsetValue + "vw;";

      if (mobile) { 
        widthStyle = `width: ${member.imgProps.mobile.widthModifier}vw;`
        member.style = `margin-left: ${(100 - member.imgProps.mobile.widthModifier) / 2}vw; z-index: 500`
        member.imgStyle = widthStyle;
      } else {
        if (i < middle) {
          member.style = "margin-right:" + marginStyleValue + ";z-index: " + (zIndexBase + i) +";";
          member.imgStyle = widthStyle;
        } else if (i > middle) {
          member.style = "margin-left:" + marginStyleValue + ";z-index: " + (zIndexBase + this.team.length - i - 1) +";";
          member.imgStyle = widthStyle;
        } else {
          member.style = "z-index: " + (zIndexBase + middle) + ";";
          member.imgStyle =  widthStyle;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#teamLineup {
  background-color: $secondary-color;
  padding: 100px 0 90px 0;
}

.member {
  display: inline-block;
  position: relative;
  height: 100%;
  vertical-align: bottom;
  transition: all 0.2s;
  transform-origin: center bottom;
}
.member:hover {
  transform: scale(1.15);
  transform-origin: center bottom;
}
.member-image-container {
  position: relative;
}
h1 {
  font-size: 1vw;
  color: #fff;
  z-index: 550;
}
#container {
  width: 95vw;
  margin: 0 auto;
}

@media screen and (max-width: 600px){
  #container {
    width: 100vw;
  }

  .member-name > h1 {
    font-size: 12px;
  }
}

.bellow-container {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.above-container {
  position: relative;
  width: 100%;
}
.member-name,
.member-title {
  width: 10vw;
  margin: 0 auto;
  position: relative;
}

.member-name {
  width: 100%;
}

.member-title {
  bottom: -70px;
}

.team-lineup-title {
  font-size: 32px;
  position: relative;
  top: -90px;
}
</style>

